import React from 'react';
import './Home.css'; // create this CSS file
import myImage from '../images/mypic_w.jpeg';

const Home = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="portfolio-container">
      <div className="profile">
        <img src={myImage} alt="Akshay" />
        <h1>Akshay H Mulky</h1>
        <p>Software Enthusiast | Product Thinker | Caricaturist</p>
      </div>
      <div className="intro-text">
        Passionate about building meaningful digital experiences through code,
        creativity, and problem-solving. From building platforms like SQLjar.com
        to creating digital caricatures, I enjoy blending technology with design
        to bring ideas to life.
      </div>

      <div className="links">
        <a
          href="https://github.com/akshayhmulky"
          target="_blank"
          rel="noreferrer"
          className="github"
        >
          <i className="fab fa-github"></i> GitHub
        </a>
        <a
          href="https://www.hackerrank.com/akshay_h_mulky"
          target="_blank"
          rel="noreferrer"
          className="hackerrank"
        >
          <i className="fab fa-hackerrank"></i> HackerRank
        </a>
        <a
          href="https://medium.com/@akshayhmulky"
          target="_blank"
          rel="noreferrer"
          className="medium"
        >
          <i className="fab fa-medium"></i> Medium
        </a>
        <a
          href="https://www.instagram.com/the_caricature_funda"
          target="_blank"
          rel="noreferrer"
          className="instagram"
        >
          <i className="fab fa-instagram"></i> Caricature Gallery
        </a>
      </div>

      <div className="projects">
        <h2>My Projects</h2>

        <div className="project-card">
          <img
            src="https://www.sqljar.com/_next/image?url=%2Flogo.png&w=64&q=75"
            alt="SQLJar Logo"
            className="project-logo"
          />
          <h3>SQLjar.com</h3>
          <p>
            A platform for learning and practicing SQL queries with an easy,
            interactive experience for developers and database enthusiasts.
          </p>

          <a
            href="https://sqljar.com"
            target="_blank"
            rel="noreferrer"
            className="project-link"
          >
            Visit Website
          </a>
        </div>
      </div>

      <footer>© {currentYear} | Built with ❤️</footer>
    </div>
  );
};

export default Home;
